import React, { useState, useEffect } from 'react';
import axios from "axios";
import config from "../../../config";


const useSumo = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        let preferredUsername = 'editor_thess'; // Default value if token is not found
        const token = localStorage.getItem('keycloak-token'); // Replace with your actual key name if different
        if (token) {
            // 2. Decode the JWT (split into parts: header.payload.signature)
            const payloadBase64 = token.split('.')[1];
            const payloadJson = atob(payloadBase64); // Decode from Base64
            const payload = JSON.parse(payloadJson);

            // 3. Extract preferred_username
            preferredUsername = payload.preferred_username;

            console.log('Preferred Username:', preferredUsername);
        } else {
            console.error('Keycloak token not found in localStorage');
        }

        const fetchData = async () => {
            try {
                setLoading(true);
                setError(null);
                const response = await axios.get(config.MAP_MATCHING_API_URL + `/sumo/runs/${preferredUsername}`, {
                    headers: {
                        'X-API-Key': config.MAP_MATCHING_API_TOKEN
                    }
                });
                setData(response.data); // Save API data to state
                setLoading(false); // Data is loaded
            } catch (err) {
                setError("Error loading Sumo data.");
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    return { data, loading, error };
};

export default useSumo;